var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"never"}},[_c('div',{staticClass:"box",style:({height:_vm.BoxHeight})},[_c('div',{staticClass:"tips"},[_c('i',{staticClass:"iconfont icon-presentfill"}),_c('div',{staticClass:"tips-text"},[_vm._v("服务接入中，敬请期待！")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }